const desktopButtons={
  display: "inline-block",
  borderRadius: "0",
  padding: "0",
  WebkitBoxShadow: "0 0 0 #fff",
  boxShadow: "0 0 0 #fff",
  width: "20%",
  margin:"0",
  maxWidth: "250px",
  fontFamily: "Roboto",
  fontSize:"22px",
  color: "#444444",
  textAlign: "center",
  lineHeight: "24px",
  wordWrap: "break-word",
  minWidth: "120px",
  backgroundColor:"#EAF5FB", 
  height:"100%",
  cursor:"pointer",
  float:"left",
  textTransform:"uppercase",
}
const mobileButtons={
  display: "inline-block",
  borderRadius: "0",
  padding: "32px 0px 24px 0px",
  WebkitBoxShadow: "0 0 0 #fff",
  boxShadow: "0 0 0 #fff",
  width: "100%",
  margin:"0 25% 0 auto",
  fontFamily: "Roboto",
  fontSize:"24px",
  color: "#444444",
  textAlign: "center",
  lineHeight: "24px",
  wordWrap: "break-word",
  minWidth: "120px",
  backgroundColor:"#EAF5FB", 
  height:"100%",
  cursor:"pointer",
  float:"left",
  textTransform:"uppercase",
  borderTop:"1px solid #888",
}

const mmStyles = {
  buttons:window.innerWidth>899?desktopButtons:mobileButtons,
  
  container:{
      backgroundColor:"#EAF5FB", 
      height:"105px"
  },
  hidden:{
    position:"absolute",
    left:"-10000px",
    top:"auto",
    width:"1px",
    height:"1px",
    overflow:"hidden",
    borderRight:"0px solid #444",
    margin:0,
  },
  visible:{
    position:"relative",
    float:"left",
    
    width:"100%",
  },
  
}

export default mmStyles;
